//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

function PromoCode() {
  const { handleResponse, handleError } = HandleApiResponse();

  // always send a JSON object, so the backend never receives query=undefined
  async function getPromoCodes(values = {}) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      };
      const query = encodeURIComponent(JSON.stringify(values || {}));
      let res = await fetch(
        `${config.host}/cdr-panel/promo-code-creation?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getPromoCodeExport(values = {}) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      };
      const query = encodeURIComponent(JSON.stringify(values || {}));
      let res = await fetch(
        `${config.host}/cdr-panel/promo-code-creation/export?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function createPromoCode(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/promo-code-creation`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function updatePromoCode(values) {
    try {
      const obj = {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/promo-code-creation`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  return {
    getPromoCodes,
    getPromoCodeExport,
    createPromoCode,
    updatePromoCode
  };

}

export default PromoCode;